import React from 'react'

const TrashIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="trashGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 80, 100, 1)" />
          <stop offset="100%" stopColor="rgba(220, 50, 80, 1)" />
        </linearGradient>
        <filter id="trashGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Trash can body */}
      <path 
        d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"
        stroke="url(#trashGradient)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        filter="url(#trashGlow)"
      />
      
      {/* Trash lines */}
      <line 
        x1="10" 
        y1="11" 
        x2="10" 
        y2="17" 
        stroke="url(#trashGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line 
        x1="14" 
        y1="11" 
        x2="14" 
        y2="17" 
        stroke="url(#trashGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default TrashIcon
